import styled from 'styled-components';

export const EnvironmentBannerStyles = styled.div`
  color: red;
  border: solid 1px;
  padding: 0.3rem 1rem;
  border-radius: 6px;
`;
